// ------------------------------------
// props 輸入需求 :
// props.toggleDropdown : boolean                   (react usestate)
// props.hide : function( void )                    ( 開關按鈕 )
// props.data : object : { data: array }            ( dropdown 真正的選擇內容 : lng 種類 )
// props.returndata : function( params: str )       ( 帶入選取值 string )
// ------------------------------------

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SET_DROPDOWN, SET_PAGE } from '../../stores/reducer_HistoryPage';

const DropdownHis = (props) => {
    const {t} = useTranslation()
    const store_his = useSelector(state=>state.store_hisPage)
    const dispatch = useDispatch()
    const page = props.data.page
    const Parrel = props.data.keys.map((k, index)=>{
        const rightPage = (store_his.page === page)
        const rightDropDown = (store_his.dropDown === index)
        return (
            <div key={index+k} className="fx-d-c" onClick={(e)=>{
                    e.stopPropagation();
                    dispatch(SET_PAGE(page))
                    dispatch(SET_DROPDOWN(index));
                }}>
                <div className={`parallel hisDrop ${rightPage && rightDropDown? "first":"second"} slash fx-ccc pad-3 b pad-5 t`} >
                    <div className="unselc">
                        {t(k)}
                    </div>
                </div>
            </div>
            )
        }
    )

    return (
        <div className="pos-a top-calc z-10 hisdropFrame fx-d-c parallel-before-his">
            {Parrel}
        </div>
        //  <div className="pos-a z-1 hisdropFrame fx-d-c skew skew-his parallel-before-his">
        //     {Parrel}
        // </div>
    )
}

export default DropdownHis;